import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks/hooks';
import * as R from 'ramda';
import { agents } from '../../../../../../redux/agents/action';
import { jobs } from '../../../../../../redux/jobs/action';
import { selectJobsQueryItems } from '../../../../../../redux/jobs/selector';
import { selectListItems as selectLibraryListItems } from "../../../../../../redux/library/selector";
import { settings } from '../../../../../../redux/settings/actions';
import { cancelReasons } from '../../../../../../redux/cancel-reasons/action';
import CommonModal from '../../../../../../models/common-modal';
import { selectCurrent } from '../../../../../../redux/settings/selectors';
import { CancelReasonComponents } from '../../../../../../common/components/cancel-reasons.component';
import { selectCancelReasonsListItems } from '../../../../../../redux/cancel-reasons/selector';
import { orders } from '../../../../../../redux/orders/action';
import { selectOrdersListItems } from '../../../../../../redux/orders/selector';
import { selectAgentsListItems } from '../../../../../../redux/agents/selector';
import PageLoader from '../../../../../../components/PageLoader';
import TripComponent from '../components/trip.component';
import { trips } from '../../../../../../redux/trips/action';
import { selectTripsQueryItems } from '../../../../../../redux/trips/selector';
import UploadFiles from '../../../../../../models/UploadFile';
import { deepCopy } from '../../../../../../common/services/common.service';

let currentChange: any = {}
const TransportAgentTrip = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [
        anchorShipmentEl,
        setAnchorShipmentEl
    ] = React.useState(null);
    const [
        selectedValue,
        setSelectedValue
    ] = useState<any>();
    const cancelitemsData = useSelector(selectCancelReasonsListItems)
    const { getCommonModal } = useAppSelector(selectCurrent)
    const tripsQuery = useSelector(selectTripsQueryItems)
    const libraryData = useSelector(selectLibraryListItems)
    const transportAgentListItems = useSelector(selectAgentsListItems)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [isOrder, setIsOrder] = useState<boolean>(false)
    const orderListData = useSelector(selectOrdersListItems)
    const [generateIds, setGenerateIds] = useState<any>([]);
    const [
        tripsDetails,
        setTripsDetails
    ] = useState<any>([])
    const [
        orderDetails,
        setOrderDetails
    ] = useState<any>([])
    const [
        mediaFiles,
        setMediaFiles
    ] = useState<any>([])
    const [
        imageIndex,
        setImageIndex
    ] = useState<any>([])
    const [
        openFile,
        setOpenFile
    ] = useState<any>([]);
    const { getUploadFiles } = useAppSelector(selectCurrent)


    const fetchTripsById = async () => {
        await dispatch(trips.query({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/trips/query`, entity: 'trips', jsonData: {

                Context: {},
                Records: [
                    {

                        Id: parmas?.id


                    }
                ]

            }
        }))
        await setIsQuery(true)


    }

    const fetchOrders = async () => {
        await dispatch(orders.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/shipments/list`, entity: 'order', jsonData: {

                Filters: [
                    {
                        "FilterOperatorId": 1,
                        "FieldName": "Id",
                        "FieldValue": tripsQuery?.result?.items?.ShipmentId,
                        "FieldType": "number"
                    }
                ],

            }
        }))
        await setIsOrder(true)
    }
    const getTransporterAgentName = (TransportAgentId: any) => {
        const transportagentName = R.find(
            (transportagent: any) => parseInt(
                transportagent.Id,
                10
            ) === parseInt(
                TransportAgentId,
                10
            ),
            transportAgentListItems.result.items

        )
        return transportagentName ? transportagentName.Name : ''

    }
    const generateUniqueId = () => {
        const randomPart = Math.random().toString(36).substr(2, 9); // Random part
        const timestampPart = Date.now().toString(36); // Timestamp part
        return `${randomPart}-${timestampPart}`;
    };


    const generateIdValue = () => {
        const newItem = {
            transaction_id: generateUniqueId(),
            message_id: generateUniqueId(),
        };
        setGenerateIds(newItem);
    };
    useEffect(
        () => {
            dispatch(agents.list({
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/transport-agents/list`, entity: 'agents', jsonData: {

                }
            }))
            if (parmas?.id > 0) {
                fetchTripsById()
                generateIdValue()

            } else {
                setIsLoading(false)
            }
        },
        []
    )
    const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
        const localSelectedmedia = deepCopy(selectedMediaFilesArg)
        const newsSelectedMedia = {
            Id: 0,
            FileTypeId: 0,
            OwnerId: parmas?.id,
            OwnerType: 'shipping',
            OwnerTypeId: 1007,
            FileMappingURL: ''
        }
        if (localSelectedmedia.length === 0 ||
            localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
        ) {
            localSelectedmedia?.push(newsSelectedMedia)
        }

        return localSelectedmedia
    }
    const setMediaInfo = async () => {
        let localSelectedMedia = deepCopy(mediaFiles)
        localSelectedMedia.splice(
            currentChange.idx,
            1,
            { ...localSelectedMedia[currentChange.idx] }
        );
        localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
        currentChange.field = 'FileTypeIdDONE'
        setMediaFiles(localSelectedMedia)
    }
    const changeImage = (idx: number, templateField: any, fileType: any) => {
        setImageIndex(idx)
        dispatch(settings.set({ getUploadFiles: 'open' }))
        setOpenFile({
            currentFileSrc: mediaFiles[idx][templateField],
            folder: 'shipping',
            type: fileType
        })
    }
    const handleSubmit = (data: any) => {

        mediaFiles[imageIndex].FileMappingURL = data

    }
    const handleClose = () => {
        dispatch(settings.set({ getUploadFiles: 'close' }))

    }
    const handleFormMediaItemChange: any = ({ value, field, idx }: any) => {
        const items = deepCopy(mediaFiles);// deep copy of grn items
        let item = items[idx];// deep copy of item to be edited
        item = { ...item, [field]: value }// updated the particular item
        items[idx] = item;
        currentChange = { value, field, idx }
        setMediaFiles(items);
    }

    // useEffect(
    //   () => {
    //     if (currentChange.field === 'FileTypeId') {
    //       setMediaInfo()
    //     }
    //   },
    //   [mediaFiles]
    // )


    useEffect(
        () => {
            if (isQuery) {
                localStorage.setItem("Cargostartpoint", tripsQuery?.result?.items?.fulfillments[0]?.start?.location?.gps)
                localStorage.setItem("Cargoendpoint", tripsQuery?.result?.items?.fulfillments[0]?.end?.location?.gps)
                setTripsDetails(tripsQuery?.result?.items)
                fetchOrders()
                const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: tripsQuery?.result?.items?.fulfillments[0]?.EWayBill?.MediaFiles });
                setMediaFiles(localSelectedMedia)
                setIsLoading(false)
            }
        },
        [isQuery]
    )
    useEffect(
        () => {

            if (isOrder) {
                setOrderDetails(orderListData?.result?.items[0])
            }
        },
        [orderListData]
    )

    const getShippingType = (id: any) => {
        const typeData = R.find(
            (requestType: any) => parseInt(
                requestType.Value,
                10
            ) === parseInt(
                id,
                10
            ),
            libraryData.result.CargoTripsStatus
        )
        return typeData ? typeData.Text : ''
    }

    const ConvertMinutes = (num: any) => {
        const d = Math.floor(num / 1440); // 60*24
        const h = Math.floor((num - (d * 1440)) / 60);
        const m = Math.round(num % 60);

        const Days = ''
        if (d > 0) {
            return (`${d} Days and  ${h} Hours  and ${m} Minutes`);
        } else if (h > 0) {
            return (`${h} Hours and ${m} Minutes`);
        }
        return (`${m} Minutes`);
    }
    const back = () => {
        navigate('/transport-agent/logistics/transport/trips')
    }
    const handleMenuClose = () => {
        setAnchorShipmentEl(null)
    };
    const handleRejectOpen = async () => {
        await dispatch(settings.set({ getCommonModal: 'open' }))
        await dispatch(cancelReasons.list({
            url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/dom/cancel-reasons/list`, entity: 'cancelReasons', jsonData: {

                Filters: [
                    {
                        FieldName: 'CanceledBy',
                        FilterOperatorId: 6,
                        FieldValue: 30,
                        FieldType: 'text'
                    }
                ]


            }
        }))

    };
    const handleCancelation = () => {
        return (
            <CancelReasonComponents
                cancelreason={cancelitemsData?.result?.items}
                onFormChange={onFormChange}
                selectedValue={selectedValue}
            />
        );
    };
    const handleCancelationClose = () => {
        setSelectedValue({})
        dispatch(settings.set({ getCommonModal: 'close' }))
    }
    const onFormChange: any = ({ field, value }: any) => {
        setSelectedValue({ ...selectedValue, [field]: value })
    }
    const handleOrderCancelSubmit = () => {

        handleShipmentStatusClick(
            -10,
            selectedValue?.Code
        )

        handleMenuClose()
        setSelectedValue({})
    }

    const handleShipmentStatusClick = async (event: any, code: any) => {
        if (event === -10) {
            await dispatch(orders.update({
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/shipping-status`, entity: 'orders', jsonData: {

                    Records: [{
                        context: {
                            "transaction_id": generateIds?.transaction_id,
                            "message_id": generateIds?.message_id,
                        },
                        Message: {
                            Id: tripsDetails?.ShipmentId,
                            AgentId: tripsDetails?.fulfillments[0]?.agent?.id,
                            ShipmentId: tripsDetails?.ShipmentId,
                            JobId: tripsDetails?.JobId,
                            ShippingStatusId: event,
                            Code: code
                        }
                    }
                    ]
                }
            }))
            await handleCancelationClose()
            setTimeout(async () => {
                await back()
            }, 2000);

        } else {

            dispatch(orders.update({
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/shipping-status`, entity: 'orders', jsonData: {
                    Records: [{
                        context: {
                            "transaction_id": generateIds?.transaction_id,
                            "message_id": generateIds?.message_id,
                        },
                        Message: {
                            Id: tripsDetails?.ShipmentId,
                            AgentId: tripsDetails?.fulfillments[0]?.agent?.id,
                            ShipmentId: tripsDetails?.ShipmentId,
                            JobId: tripsDetails?.JobId,
                            ShippingStatusId: event,
                        }
                    }
                    ]

                }
            }))
            await handleCancelationClose()
            setTimeout(async () => {
                await back()
            }, 2000);
        }

    };
    return (
        <>
            {getUploadFiles == 'open' && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
                folder={openFile?.folder}
                handleClose={handleClose}
                handleFilesSubmit={handleSubmit}
                type={openFile?.type}
                ownerId={parmas?.id}
            />}
            {getCommonModal == 'open' && <CommonModal title='Cancel Confirmation' renderForm={handleCancelation}
                onSubmit={handleOrderCancelSubmit}
                handleClose={handleCancelationClose}
            />}
            {isLoading ? <PageLoader /> :
                <TripComponent
                    mediaFiles={mediaFiles}
                    handleFormMediaItemChange={handleFormMediaItemChange}
                    fileTypes={libraryData?.result?.FileType}
                    changeImage={changeImage}
                    back={back}
                    orderDetails={orderDetails}
                    tripsDetails={tripsDetails}
                    getShippingType={getShippingType}
                    getTransporterAgentName={getTransporterAgentName}
                    handleShipmentClick
                    ConvertMinutes={ConvertMinutes}
                    handleShipmentStatusClick={handleShipmentStatusClick}
                    handleMenuClose={handleMenuClose}
                    handleRejectOpen={handleRejectOpen}
                    anchorShipmentEl={anchorShipmentEl}
                    setAnchorShipmentEl={setAnchorShipmentEl}
                />}
        </>
    )

}

export default TransportAgentTrip;